'use client';
import { FilpCarousel } from '@/components/atoms/Carousel';
import NewsCarouselItem from './NewsCarouselItem';
import { useQuery } from '@tanstack/react-query';
import { getNewsLists } from './getNewsLists';

type News = {
  title: string;
  newsId: number;
  categoryId: number;
  publishAt: number;
};

const Empty = () => <div className='h-10 w-full rounded-lg bg-[#e2e8f180]' />;

const FilpNewsCarouselClient = () => {
  const { data } = useQuery({
    queryKey: ['forex-news-carousel'],
    queryFn: getNewsLists,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    placeholderData: prev => prev
  });

  if (!data || data?.length === 0) return <Empty />;

  return (
    <FilpCarousel speed={5000} style='h-[40px]' delay={1000}>
      {data.map((item: News) => (
        <NewsCarouselItem news={item} key={item.newsId} />
      ))}
    </FilpCarousel>
  );
};

export default FilpNewsCarouselClient;
